const prefix = 'rsmedl_';

const clearAll = () => {
    sessionStorage.clear();
    // sessionStorage.removeItem(prefix+'sid');
    // sessionStorage.removeItem(prefix+'f_t');
    // sessionStorage.removeItem(prefix+'a_t');
    // sessionStorage.removeItem(prefix+'t_ex');
    // sessionStorage.removeItem(prefix+"def_files");
    // sessionStorage.removeItem(prefix+'biz_const');
    // sessionStorage.removeItem(prefix+'prod_type');
    // sessionStorage.removeItem(prefix+'rno');
    // sessionStorage.removeItem(prefix+'comp_type_code');
    // sessionStorage.removeItem(prefix+'ap_sd');
    // sessionStorage.removeItem(prefix+'p_wcl');
    // sessionStorage.removeItem(prefix+'app_st');
    // sessionStorage.removeItem(prefix+'f_p');
    // sessionStorage.removeItem(prefix+"pur_pbf");
}

const setStateId  = (sid) => {
    sessionStorage.setItem(prefix+'sid', sid);//state_id
}

const getStateId = () => {
    return sessionStorage.getItem(prefix+'sid');//state_id
}

const setIsFirstTime = (value) => {
    sessionStorage.setItem(prefix+'f_t', value);//first_time
}

const getIsFirstTime = () => {
    return sessionStorage.getItem(prefix+'f_t');//first_time
}

const setToken = (token) => {
    sessionStorage.setItem(prefix+'a_t', token);//auth_token
}
 
const getToken = () => {
    return sessionStorage.getItem(prefix+'a_t');//auth_token
}

const setTokenExpiry = (expiredDate) => {
    sessionStorage.setItem(prefix+'t_ex', expiredDate); //token_expired
}

const getTokenExpiry = () => {
    return sessionStorage.getItem(prefix+'t_ex'); //token_expired
}

const setFilesArray = (files) => {
    sessionStorage.setItem(prefix+"def_files", JSON.stringify(files));
}

const getFilesArray = () => {
   return JSON.parse(sessionStorage.getItem(prefix+"def_files") || "[]");
}

const setBizConstStatus= (status) => {
    sessionStorage.setItem(prefix+'biz_const', status);
}

const getBizConstStatus = (status) => {
    return sessionStorage.getItem(prefix+'biz_const');
}

const setProductType = (option) => {
    sessionStorage.setItem(prefix+'prod_type', option);
}

const getProductType = (status) => {
    return sessionStorage.getItem(prefix+'prod_type');
}

const setRefNo = (refno) => {
    sessionStorage.setItem(prefix+'rno', refno);//ref_no
}

const getRefNo = () => {
    return sessionStorage.getItem(prefix+'rno');//ref_no
}

const setCompType = (coType)=> {
    sessionStorage.setItem(prefix+'comp_type_code', coType);
}

const getCompType = ()=> {
    return sessionStorage.getItem(prefix+'comp_type_code');
}

const setIsAPSavedForm = (isSaved) =>{
    sessionStorage.setItem(prefix+'ap_sd',isSaved); //is_AP_Saved
}

const getIsAPSavedForm = ()=> {
    return sessionStorage.getItem(prefix+'ap_sd'); //is_AP_Saved
}

const setIsProductWCL = (isWCL) => {
    sessionStorage.setItem(prefix+'p_wcl',isWCL); //is_Product_WCL
}

const getIsProductWCL = ()=> {
    return sessionStorage.getItem(prefix+'p_wcl');//is_Product_WCL
}

const setAppStage = (status) => {
    sessionStorage.setItem(prefix+'app_st',status);
}

const getAppStage = ()=> {
    return sessionStorage.getItem(prefix+'app_st');
}

const setIsFProdBTL = (isBTL) => {
    sessionStorage.setItem(prefix+'p_btl',isBTL); //is_Product_BTL
}

const getIsFProdBTL = ()=> {
    return sessionStorage.getItem(prefix+'p_btl');//is_Product_BTL
}

const setIsFPTypeProperty = (isProperty) => {
    sessionStorage.setItem(prefix+'pt_prty',isProperty); //is_product_PBF_Property
}

const getIsFPTypeProperty = () => {
    return sessionStorage.getItem(prefix+'pt_prty'); //is_product_PBF_Property
}

const setShowNonLending = (value) => {
    sessionStorage.setItem(prefix+'nls',value); 
}

const getShowNonLending = () => {
    return sessionStorage.getItem(prefix+'nls'); //is_product_PBF_Property
}

const setIsPureAIP = (isPurAIP) => {
    sessionStorage.setItem(prefix+'is_p_aip',isPurAIP);
}

const getIsPureAIP = () => {
    return sessionStorage.getItem(prefix+'is_p_aip'); 
}

const setIsAIPSubmission = (isAIP) => {
    sessionStorage.setItem(prefix+'is_aip_subt',isAIP);
}

const getIsAIPSubmission = () => {
    return sessionStorage.getItem(prefix+'is_aip_subt'); 
}

const setIsGreenAP = (isAIP) => {
    sessionStorage.setItem(prefix+'is_g_ap',isAIP);
}

const getIsGreenAP = () => {
    return sessionStorage.getItem(prefix+'is_g_ap'); 
}

export default {
    setStateId,
    getStateId,
    setToken,
    getToken,
    setTokenExpiry,
    getTokenExpiry,
    setFilesArray,
    getFilesArray,
    setBizConstStatus,
    getBizConstStatus,
    setProductType,
    getProductType,
    setIsFirstTime,
    getIsFirstTime,
    setRefNo,
    getRefNo,
    setCompType,
    getCompType,
    setIsAPSavedForm,
    getIsAPSavedForm,
    setIsProductWCL,
    getIsProductWCL,
    setAppStage,
    getAppStage,
    setIsFProdBTL,
    getIsFProdBTL,
    setIsFPTypeProperty,
    getIsFPTypeProperty,
    setShowNonLending,
    getShowNonLending,
    setIsPureAIP,
    getIsPureAIP,
    setIsAIPSubmission,
    getIsAIPSubmission,
    setIsGreenAP,
    getIsGreenAP,
    clearAll
}; 